<template>
  <figure class="grid gap-12">
    <RevIllustration
      :src
      :width="RESERVED.width"
      :height="RESERVED.height"
      alt=""
      :aria-hidden="caption?.length ? undefined : 'true'"
      loading="lazy"
      class="rounded-md w-full"
    />

    <figcaption
      v-if="caption?.length"
      class="raw-body-3 grid gap-8 text-[var(--raw-darkgrey)]"
    >
      <p v-for="(paragraph, index) in caption" :key="index">
        <InlineMarkdown :message="paragraph" />
      </p>
    </figcaption>
  </figure>
</template>

<script setup lang="ts">
import { RevIllustration } from '@ds/components/Illustration'

import InlineMarkdown from '~/scopes/campaign/components/UI/InlineMarkdown.vue'
import type { I18nDescriptor } from '~/scopes/campaign/data/metals/types'

// Every campaign photo renders here, uncropped: the photographers require their
// frames as shot, so `w-full` + the DS's `h-auto` let the file set its own height.
//
// Files are served untransformed until the optimizer in `plugins/design-system.ts`
// stops being the identity function.
defineProps<{
  src: string
  /** Pie de foto; present ⇒ the image is content, so it drops its `aria-hidden`. */
  caption?: readonly I18nDescriptor[]
}>()

// Reserves space pre-load only — `aspect-ratio: auto attr(width) / attr(height)` hands
// the box back to the file's real ratio the moment it lands.
const RESERVED = { width: 1500, height: 1000 }
</script>

<style scoped>
/* `raw-body-3`'s 1.05 leading is unreadable once a caption wraps, and a `leading-*`
   utility would only tie on specificity. */
figcaption {
  line-height: 1.35;
}
</style>
